'use client'

import React, { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import NonMemberModal from '@/components/Shared/NonMemberModal'
import { useNavigationState } from '@/hooks/useNavigationState'
import MessageAfterLogin from '@/components/Shared/MessageAfterLogin'
import { useAuth } from '@/hooks/useAuth'

export default function BlankLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  const { beforePath, removeBeforePath } = useNavigationState()
  const { getMemberId } = useAuth()

  useEffect(() => {
    const currentPathName = getRouteName(pathname)

    const excludeNames = ['talentbook_guide', 'signup']

    // 現在のパスが excludeNames 以外の場合にのみ クリア処理を実行
    if (beforePath && !excludeNames.includes(currentPathName)) {
      removeBeforePath()
    }
  }, [pathname, beforePath, removeBeforePath])

  function getRouteName(path: string | null): string {
    if (!path) return ''
    const segments = path.split('/')
    return segments[segments.length - 1] || 'index'
  }

  return (
    <div className='all_container blank'>
      <div id='main-container' className='main-container'>
        <Header />
        <div id='app'>
          <div className='lp'>{children}</div>
        </div>
        <NonMemberModal />
        <MessageAfterLogin memberId={getMemberId()} />
        <Footer />
      </div>
    </div>
  )
}
